import { formatRelativeTime } from "@equipped/core/time/relativeTime";

/**
 * Plain-English relative-time label, e.g. "2h ago" / "3d ago" / "just now" — for the
 * Audit page (docs/340-ADMIN-MANTIS-AND-API-IDEAS.md Part B), which the plan asks to show
 * "a relative + absolute format" per row. Mirrors `src/ui/RecentRow.tsx`'s
 * `relativeTimeLabel` (the app's own UI-layer string-building over the SAME pure core
 * bucket-selector, `@equipped/core/time/relativeTime`) but hardcodes English — this admin
 * app has no i18n layer (`src/ui/strings.ts`/`useT` don't apply here; every other mantis
 * page already uses plain hardcoded English strings). `>= 7d` falls back to an absolute
 * short date, exactly like the app-side helper does.
 */
export function relativeTimeLabel(nowMs: number, thenMs: number): string {
  const r = formatRelativeTime(nowMs, thenMs);
  switch (r.unit) {
    case "now":
      return "just now";
    case "minutes":
      return `${r.count}m ago`;
    case "hours":
      return `${r.count}h ago`;
    case "days":
      return `${r.count}d ago`;
    case "date":
      return new Date(thenMs).toLocaleDateString();
  }
}
